const scrollFunctions = () => {
    $(document).on('click', '.js-scroll-next-section', function(e) {
        e.preventDefault();

        const currentSection = $(this).closest('section');
        const nextSection = currentSection.next('section');
        const offset = $('.c-header').height() + 40;

        if ( nextSection.length ) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top - offset
            }, 800);
        }
    });

    ScrollTrigger.create({
        trigger: "html",
        start: "top top-=200",
        end: "bottom bottom",
        onToggle: (self) => {
            if ( $(window).width() > 1199 && !self.isActive ) {
                $('.c-nav').removeClass('hidden');
            }
        },
        onUpdate: (self) => {
            if ( $(window).width() > 1199 && self.isActive ) {
                if ( self.direction === 1 ) { // Scrolling Down
                    $('.c-nav').addClass('hidden');
                    $('.js-menus-inner-filter-section').css('margin-top', '0px');
                } else { // Scrolling Up
                    $('.c-nav').removeClass('hidden');
                    $('.js-menus-inner-filter-section').css('margin-top', '69px');
                }
            }
        }
    });  
}